export default "__VITE_ASSET__CnIVuwhm__$_?url__"